module.exports = __webpack_public_path__ + "static/operational-relationships-splash-low.1da5f833.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/operational-relationships-splash-low.jpg
// module id = 890
// module chunks = 4241802371889